import { AppState, AppStateActionParams } from 'records/AppState';

export interface EditingActions {
  beginEditing: (ActionParams: AppStateActionParams) => Promise<AppState>;

  endEditing: (ActionParams: AppStateActionParams) => Promise<AppState>;
}

const editingActions: EditingActions = {
  beginEditing: async ({ state }: AppStateActionParams): Promise<AppState> => {
    return state().set('unsavedChanges', true);
  },

  endEditing: async ({ state }: AppStateActionParams): Promise<AppState> => {
    return state().set('unsavedChanges', false);
  },
};

export default editingActions;
